import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@tanstack/react-query';
import { Mail, MailCheck } from 'lucide-react';
import { requestPasswordReset } from '../../api/auth';
import { getErrorMessage } from '../../api/errors';
import { Alert, Button, Field, Input } from '../../ui';
import styles from './auth.module.css';

export function ForgotPasswordForm({ onBack }) {
  const mutation = useMutation({ mutationFn: requestPasswordReset });

  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().trim().email('Enter a valid email address').required('Email is required'),
    }),
    onSubmit: (values) => mutation.mutate(values.email.trim()),
  });

  if (mutation.isSuccess) {
    return (
      <div className={styles.sent}>
        <span className={styles.sentIcon}>
          <MailCheck />
        </span>
        <p className={styles.sentTitle}>Check your inbox</p>
        <p className={styles.sentText}>
          If an account exists for <strong>{formik.values.email.trim()}</strong>, you’ll get a link to reset your
          password. It expires in an hour.
        </p>
        <Button variant="secondary" block onClick={onBack}>
          Back to sign in
        </Button>
      </div>
    );
  }

  return (
    <form className={styles.form} onSubmit={formik.handleSubmit} noValidate>
      {mutation.isError && <Alert tone="danger">{getErrorMessage(mutation.error)}</Alert>}
      <Field label="Email" error={(formik.touched.email && formik.errors.email) || undefined}>
        <Input type="email" autoComplete="email" inputMode="email" leading={<Mail />} {...formik.getFieldProps('email')} />
      </Field>
      <Button type="submit" size="lg" block loading={mutation.isPending}>
        Send reset link
      </Button>
      <button type="button" className={styles.inlineLink} onClick={onBack}>
        Back to sign in
      </button>
    </form>
  );
}
